import cls from 'classnames';

export const GStopPropagation: React.FC<
  React.PropsWithChildren & {
    isDisabled?: boolean;
    height?: string;
    center?: boolean;
    preventDefault?: boolean;
    onClick?: () => void;
  }
> = ({ children, isDisabled, height, center, preventDefault = true, onClick }) => {
  const stopEventPropagation = (event: React.MouseEvent | React.TouchEvent) => {
    onClick?.();
    event.stopPropagation();
    preventDefault && event.preventDefault();
  };

  return isDisabled ? (
    <>{children}</>
  ) : (
    <div
      className={cls('cursor-auto overflow-hidden', {
        'flex items-center justify-center': center,
      })}
      onClick={stopEventPropagation}
      onTouchStart={stopEventPropagation}
      style={{ height }}
    >
      {children}
    </div>
  );
};
